import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const FAQS = [{
  q: '¿Cómo recibiré el material?',
  a: 'Inmediatamente después de completar tu compra recibirás un correo electrónico con el acceso para descargar los 6 Tomos y los 5 Bonos en formato PDF.'
}, {
  q: '¿El contenido sirve para cualquier país?',
  a: 'Sí. Está desarrollado en español neutro y basado en guías internacionales ampliamente utilizadas, por lo que puede aplicarse en cualquier país de habla hispana. Además, el cambio de moneda en el checkout es automático según tu país.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí. Todo el contenido está optimizado para computadora, tablet y teléfono móvil, y también puedes imprimirlo si prefieres utilizarlo en tu consultorio.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí. Realizas un solo pago y conservas acceso permanente al material. Sin mensualidades ni renovaciones.'
}, {
  q: '¿Necesito ser especialista en obesidad?',
  a: 'No. La Ruta Clínica está diseñada para que médicos generales y especialistas puedan utilizarla como una herramienta práctica para tomar decisiones con mayor seguridad.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14" data-id="element-72" data-mp="11x8v1ruztcnx">
      <div className="mx-auto max-w-2xl" data-id="element-73" data-mp="11vny5vl7hhmw">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-74" data-mp="16nyz91ron9h1">
          Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-75" data-mp="s0m8myn0qdjs">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-navy-100 bg-cream" data-id="element-76" data-mp="iycywazkqo7g" data-mpi={i}>
                <h3 data-id="element-77" data-mp="myokbpzrgsjz">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-78" data-mp="mz6qpfg50n5m">
                    <span className="text-[15px] font-bold leading-snug text-navy-900" data-id="element-79" data-mp="2fxd986qitv7a">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brandblue transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-80" data-mp="2azbu1ww7ug13" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-81" data-mp="2yp664c8po0ka">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-82" data-mp="2ulgetf0nj4vk">
                      <p className="px-4 pb-4 text-[14px] leading-relaxed text-navy/70" data-id="element-83" data-mp="3urtqv6ks35t8">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="mt-9 flex justify-center" data-id="element-84" data-mp="cggs384t2u5w">
          <CTAButton label="RESOLVER MIS DUDAS COMPRANDO HOY" sublabel="Garantía de 7 días · Sin riesgos para ti" pulse={false} data-id="element-85" data-mp="ch8ebscijfji" />
        </div>
      </div>
    </section>;
}